export default {
    control: {
        fontSize: 14,
        fontWeight: 'normal',
        position: 'relative',
        backgroundColor: '#F0F0F0',
        minHeight: '100px'
    }
}